module.exports = __webpack_public_path__ + "img/5.2.caf5915d.svg";